<div class="product-list-container text-center" [class.d-flex]="loadingList">

  <ng-container *ctSkeleton="loadingList;
           repeat: 3;
           className: 'product-card-skeleton';">

    <ng-container *ngIf="SEND_PRODUCTS.length > 0; else noProductAvailable">

      <ng-container *ngIf="alternativeTemplate == false; else alternativeTmpl">
        
        <!-- LETTER PRODUCTS -->
        <!-- Se MENO di 4 prodotti: layout normale su tutti i breakpoint -->
        <ng-container *ngIf="LETTER_PRODUCTS.length < 4; else letterSpecialLayout">
          <div fxLayout="row wrap">
            <app-product-card fxFlex="100" [fxFlex.gt-sm]="100" [fxFlex.gt-md]="LETTER_PRODUCT_CARD_MD_FLEX"
              *ngFor="let product of LETTER_PRODUCTS" [product]="product" [selected]="control?.value === product"
              [invalid]="control.touched && control.invalid" (onSelect)="setValue($event)"></app-product-card>
          </div>
        </ng-container>

        <!-- Se 4+ prodotti: layout speciale SOLO su desktop medio (960-1280px) -->
        <ng-template #letterSpecialLayout>
          
          <!-- Desktop medio (960-1280px): layout 3-sopra-resto-sotto -->
          <div fxLayout="row wrap" fxHide fxShow.gt-md fxHide.gt-lg>
            <!-- Prima riga: 3 card al 33.33% -->
            <app-product-card fxFlex="33.33"
              *ngFor="let product of LETTER_PRODUCTS_FIRST_THREE" [product]="product" 
              [selected]="control?.value === product"
              [invalid]="control.touched && control.invalid" (onSelect)="setValue($event)"></app-product-card>
          </div>
          <div fxLayout="row wrap" fxHide fxShow.gt-md fxHide.gt-lg *ngIf="LETTER_PRODUCTS_REMAINING.length > 0">
            <!-- Seconda riga: rimanenti equamente distribuiti -->
            <app-product-card [fxFlex]="LETTER_REMAINING_FLEX"
              *ngFor="let product of LETTER_PRODUCTS_REMAINING" [product]="product" 
              [selected]="control?.value === product"
              [invalid]="control.touched && control.invalid" (onSelect)="setValue($event)"></app-product-card>
          </div>

          <!-- Mobile/Tablet (<960px): layout normale -->
          <div fxLayout="row wrap" fxShow fxHide.gt-md>
            <app-product-card fxFlex="100" [fxFlex.gt-sm]="100"
              *ngFor="let product of LETTER_PRODUCTS" [product]="product" [selected]="control?.value === product"
              [invalid]="control.touched && control.invalid" (onSelect)="setValue($event)"></app-product-card>
          </div>

          <!-- Desktop large (>1280px): layout normale dinamico -->
          <div fxLayout="row wrap" fxHide fxShow.gt-lg>
            <app-product-card [fxFlex]="LETTER_PRODUCT_CARD_MD_FLEX"
              *ngFor="let product of LETTER_PRODUCTS" [product]="product" [selected]="control?.value === product"
              [invalid]="control.touched && control.invalid" (onSelect)="setValue($event)"></app-product-card>
          </div>

        </ng-template>

        <!-- DIGITAL PRODUCTS -->
        <ng-container *ngIf="DIGITAL_PRODUCTS.length">

          <!-- Se MENO di 4 prodotti: layout normale su tutti i breakpoint -->
          <ng-container *ngIf="DIGITAL_PRODUCTS.length < 4; else digitalSpecialLayout">
            <div fxLayout="row wrap">
              <app-product-card fxFlex="100" [fxFlex.gt-md]="DIGITAL_PRODUCT_CARD_MD_FLEX"
                *ngFor="let product of DIGITAL_PRODUCTS" [product]="product" [selected]="control?.value === product"
                [invalid]="control.touched && control.invalid" (onSelect)="setValue($event)"></app-product-card>
            </div>
          </ng-container>

          <!-- Se 4+ prodotti: layout speciale SOLO su desktop medio (960-1280px) -->
          <ng-template #digitalSpecialLayout>
            
            <!-- Desktop medio (960-1280px): layout 3-sopra-resto-sotto -->
            <div fxLayout="row wrap" fxHide fxShow.gt-md fxHide.gt-lg>
              <!-- Prima riga: 3 card al 33.33% -->
              <app-product-card fxFlex="33.33"
                *ngFor="let product of DIGITAL_PRODUCTS_FIRST_THREE" [product]="product" 
                [selected]="control?.value === product"
                [invalid]="control.touched && control.invalid" (onSelect)="setValue($event)"></app-product-card>
            </div>
            <div fxLayout="row wrap" fxHide fxShow.gt-md fxHide.gt-lg *ngIf="DIGITAL_PRODUCTS_REMAINING.length > 0">
              <!-- Seconda riga: rimanenti equamente distribuiti -->
              <app-product-card [fxFlex]="DIGITAL_REMAINING_FLEX"
                *ngFor="let product of DIGITAL_PRODUCTS_REMAINING" [product]="product" 
                [selected]="control?.value === product"
                [invalid]="control.touched && control.invalid" (onSelect)="setValue($event)"></app-product-card>
            </div>

            <!-- Mobile/Tablet (<960px): layout normale -->
            <div fxLayout="row wrap" fxShow fxHide.gt-md>
              <app-product-card fxFlex="100"
                *ngFor="let product of DIGITAL_PRODUCTS" [product]="product" [selected]="control?.value === product"
                [invalid]="control.touched && control.invalid" (onSelect)="setValue($event)"></app-product-card>
            </div>

            <!-- Desktop large (>1280px): layout normale dinamico -->
            <div fxLayout="row wrap" fxHide fxShow.gt-lg>
              <app-product-card [fxFlex]="DIGITAL_PRODUCT_CARD_MD_FLEX"
                *ngFor="let product of DIGITAL_PRODUCTS" [product]="product" [selected]="control?.value === product"
                [invalid]="control.touched && control.invalid" (onSelect)="setValue($event)"></app-product-card>
            </div>

          </ng-template>

        </ng-container>

      </ng-container>

      <ng-template #alternativeTmpl>

        <!-- TEMPLATE ALTERNATIVO (BPER): DIGITAL PRIMA, POI LETTER -->
        
        <!-- DIGITAL PRODUCTS -->
        <ng-container *ngIf="DIGITAL_PRODUCTS.length">

          <!-- Se MENO di 4 prodotti: layout normale -->
          <ng-container *ngIf="DIGITAL_PRODUCTS.length < 4; else digitalSpecialLayoutAlt">
            <div fxLayout="row wrap">
              <app-product-card fxFlex="100" [fxFlex.gt-md]="DIGITAL_PRODUCT_CARD_MD_FLEX"
                *ngFor="let product of DIGITAL_PRODUCTS" [product]="product" [selected]="control?.value === product"
                [invalid]="control.touched && control.invalid" (onSelect)="setValue($event)"></app-product-card>
            </div>
          </ng-container>

          <!-- Se 4+ prodotti: layout speciale -->
          <ng-template #digitalSpecialLayoutAlt>
            <div fxLayout="row wrap" fxHide fxShow.gt-md fxHide.gt-lg>
              <app-product-card fxFlex="33.33"
                *ngFor="let product of DIGITAL_PRODUCTS_FIRST_THREE" [product]="product" 
                [selected]="control?.value === product"
                [invalid]="control.touched && control.invalid" (onSelect)="setValue($event)"></app-product-card>
            </div>
            <div fxLayout="row wrap" fxHide fxShow.gt-md fxHide.gt-lg *ngIf="DIGITAL_PRODUCTS_REMAINING.length > 0">
              <app-product-card [fxFlex]="DIGITAL_REMAINING_FLEX"
                *ngFor="let product of DIGITAL_PRODUCTS_REMAINING" [product]="product" 
                [selected]="control?.value === product"
                [invalid]="control.touched && control.invalid" (onSelect)="setValue($event)"></app-product-card>
            </div>
            <div fxLayout="row wrap" fxShow fxHide.gt-md>
              <app-product-card fxFlex="100"
                *ngFor="let product of DIGITAL_PRODUCTS" [product]="product" [selected]="control?.value === product"
                [invalid]="control.touched && control.invalid" (onSelect)="setValue($event)"></app-product-card>
            </div>
            <div fxLayout="row wrap" fxHide fxShow.gt-lg>
              <app-product-card [fxFlex]="DIGITAL_PRODUCT_CARD_MD_FLEX"
                *ngFor="let product of DIGITAL_PRODUCTS" [product]="product" [selected]="control?.value === product"
                [invalid]="control.touched && control.invalid" (onSelect)="setValue($event)"></app-product-card>
            </div>
          </ng-template>

        </ng-container>

        <!-- LETTER PRODUCTS -->
        <!-- Se MENO di 4 prodotti: layout normale -->
        <ng-container *ngIf="LETTER_PRODUCTS.length < 4; else letterSpecialLayoutAlt">
          <div fxLayout="row wrap">
            <app-product-card fxFlex="100" [fxFlex.gt-sm]="100" [fxFlex.gt-md]="LETTER_PRODUCT_CARD_MD_FLEX"
              *ngFor="let product of LETTER_PRODUCTS" [product]="product" [selected]="control?.value === product"
              [invalid]="control.touched && control.invalid" (onSelect)="setValue($event)"></app-product-card>
          </div>
        </ng-container>

        <!-- Se 4+ prodotti: layout speciale -->
        <ng-template #letterSpecialLayoutAlt>
          <div fxLayout="row wrap" fxHide fxShow.gt-md fxHide.gt-lg>
            <app-product-card fxFlex="33.33"
              *ngFor="let product of LETTER_PRODUCTS_FIRST_THREE" [product]="product" 
              [selected]="control?.value === product"
              [invalid]="control.touched && control.invalid" (onSelect)="setValue($event)"></app-product-card>
          </div>
          <div fxLayout="row wrap" fxHide fxShow.gt-md fxHide.gt-lg *ngIf="LETTER_PRODUCTS_REMAINING.length > 0">
            <app-product-card [fxFlex]="LETTER_REMAINING_FLEX"
              *ngFor="let product of LETTER_PRODUCTS_REMAINING" [product]="product" 
              [selected]="control?.value === product"
              [invalid]="control.touched && control.invalid" (onSelect)="setValue($event)"></app-product-card>
          </div>
          <div fxLayout="row wrap" fxShow fxHide.gt-md>
            <app-product-card fxFlex="100" [fxFlex.gt-sm]="100"
              *ngFor="let product of LETTER_PRODUCTS" [product]="product" [selected]="control?.value === product"
              [invalid]="control.touched && control.invalid" (onSelect)="setValue($event)"></app-product-card>
          </div>
          <div fxLayout="row wrap" fxHide fxShow.gt-lg>
            <app-product-card [fxFlex]="LETTER_PRODUCT_CARD_MD_FLEX"
              *ngFor="let product of LETTER_PRODUCTS" [product]="product" [selected]="control?.value === product"
              [invalid]="control.touched && control.invalid" (onSelect)="setValue($event)"></app-product-card>
          </div>
        </ng-template>

      </ng-template>

    </ng-container>

    <ng-template #noProductAvailable>

      <p class="text-center"> Non ci sono prodotti attivi per la tua utenza. </p>

    </ng-template>

  </ng-container>

  <ng-container *ngIf="control.touched && control.invalid">

    <p><small style="color: red">* Selezionare un prodotto</small></p>

  </ng-container>

</div>
